import { FC, useState } from 'react';
import {
    FeedPropertyDefinitions,
    TransformedFeedDefinitionPropertyState,
} from '../../../../../../types/Endpoints/feeds';
import * as S from '../../styles';

const CUSTOM_LABEL_PREFIX = 'custom_label_';

interface AttributeProps {
    item: FeedPropertyDefinitions[number];
    props: TransformedFeedDefinitionPropertyState;
    onInputChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
    setItemIsDuplicateProductType: (key: string, value: boolean) => void;
}

export const Attribute: FC<AttributeProps> = ({
    item,
    props,
    onInputChange,
    setItemIsDuplicateProductType,
}) => {
    const keyIndex = item.key.split(CUSTOM_LABEL_PREFIX)[1];
    const disabled = +keyIndex ? !props[CUSTOM_LABEL_PREFIX + (+keyIndex - 1)]?.isEnabled : false;

    const [isDuplicateProductType, setIsDuplicateProductType] = useState(props[item.key].isDuplicateProductType);

    const { allowDuplicateProductType } = item;

    const handleSetIsDuplicateProductType = (value: boolean) => {
        setIsDuplicateProductType(value);
        setItemIsDuplicateProductType(item.key, value);
    };

    return (
        <S.Row key={item.key}>
            <S.StyledInput
                name={item.key}
                onChange={e => onInputChange(e)}
                value={props[item.key].value ?? ''}
                placeholder={item.name}
                typeInput="text"
                maxLength={255}
                title={item.name}
                disabled={(allowDuplicateProductType && isDuplicateProductType) ? isDuplicateProductType : disabled}
            />
            {item.allowDuplicateProductType && (
                <S.StyledCheckbox
                    name="Дублировать product_type"
                    title="Дублировать product_type"
                    checked={isDuplicateProductType}
                    onChange={() => handleSetIsDuplicateProductType(!isDuplicateProductType)}
                />
            )}
        </S.Row>
    );
};
